import Marquee from "react-fast-marquee";
import { Flower2 } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

export const ServicesMarquee = () => {
  const { t } = useLanguage();

  return (
    <div data-testid="services-marquee" className="bg-creamdark border-y border-line py-8 lg:py-10 overflow-hidden">
      <Marquee speed={28} gradient={false} pauseOnHover>
        {t.marquee.map((word, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif italic font-medium text-4xl md:text-5xl lg:text-6xl text-ink/80 px-8">
              {word}
            </span>
            <Flower2 size={26} strokeWidth={1.5} className="text-terra shrink-0" />
          </span>
        ))}
      </Marquee>
    </div>
  );
};
